export default __webpack_public_path__ + "static/media/youtube.d33893a4.png";